<div class="container">
  <bzg-tab-set [itemSelected]="selectedTab" (onSelectTab)="selectedTab = $event.index">
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'MAINTENANCE.TITLE_MAINTENANCE' | translate | uppercase}}">
        <maintenance-window [status]="statusType" [showLoading]="showLoading" (maintenanceEmitter)="changeStatus()"></maintenance-window>
    </bzg-tab-item>
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'MAINTENANCE.FULL_SERVICE_RESTART' | translate | uppercase}}" *ngIf="enableShowFullServiceRestart">
        <full-restart-service [status]="fullServiceRestartStatus" [showLoading]="showLoadingRestart" (restartWebApps)="restartWebApps()" (verifyServiceAvailability)="verifyServiceAvailability()"></full-restart-service>
    </bzg-tab-item>
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 2}" displayName="{{'MAINTENANCE.TITLE_MAINTENANCE_CASES' | translate | uppercase}}">
      <biz-maintenance-cases *ngIf="environment?.parameters" [parameters]="environment.parameters"></biz-maintenance-cases>
    </bzg-tab-item>
  </bzg-tab-set>
</div>
